// src/components/eventos/components/operacional/ProximoEventoCard.js
import React from 'react';

const formatarData = (dataString) => {
    if (!dataString) return 'Data não informada';
    try {
        const [ano, mes, dia] = dataString.split('T')[0].split('-');
        return `${dia}/${mes}/${ano}`;
    } catch { return 'Data inválida'; }
};

const ProximoEventoCard = ({ evento, onVerPrograma }) => (
    <div style={{ background: 'rgba(37,99,235,0.04)', border: '1px solid rgba(37,99,235,0.15)', borderRadius: '14px', padding: '20px', fontFamily: "'Inter', -apple-system, sans-serif" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: '100px', background: 'rgba(37,99,235,0.08)', border: '1px solid rgba(37,99,235,0.18)', color: '#2563eb', fontSize: '11px', fontWeight: 700, marginBottom: '10px' }}>
                    PRÓXIMO EVENTO AGENDADO
                </span>
                <h2 style={{ margin: '0 0 12px', fontSize: 'clamp(18px,3vw,24px)', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em' }}>{evento.titulo}</h2>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: evento.descricao ? '10px' : 0 }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.18)', color: '#7c3aed', fontSize: '12px', fontWeight: 600 }}>
                        📅 {formatarData(evento.data)}
                    </span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'rgba(44,203,144,0.08)', border: '1px solid rgba(44,203,144,0.18)', color: '#2CCB90', fontSize: '12px', fontWeight: 600 }}>
                        {evento.tarefas?.length || 0} tarefas
                    </span>
                </div>
                {evento.descricao && <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>{evento.descricao}</p>}
            </div>
            <button
                onClick={onVerPrograma}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '11px 20px', borderRadius: '10px', background: 'rgba(37,99,235,0.08)', border: '1px solid rgba(37,99,235,0.2)', color: '#2563eb', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s', flexShrink: 0, whiteSpace: 'nowrap' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,99,235,0.14)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(37,99,235,0.08)'}
            >
                📋 Ver Programa Completo
            </button>
        </div>

        {evento.tarefas?.length > 0 && (
            <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid rgba(37,99,235,0.1)' }}>
                <p style={{ margin: '0 0 10px', fontSize: '12px', fontWeight: 600, color: '#2563eb' }}>Tarefas programadas:</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {evento.tarefas.slice(0, 3).map((tarefa, idx) => (
                        <div key={tarefa.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                            <span style={{ padding: '2px 8px', borderRadius: '6px', background: 'rgba(37,99,235,0.06)', color: '#2563eb', fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>#{idx + 1}</span>
                            <span style={{ flex: 1, color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tarefa.titulo}</span>
                            <span style={{ color: '#94a3b8', fontSize: '12px', flexShrink: 0 }}>{tarefa.horaInicio} - {tarefa.horaFim}</span>
                        </div>
                    ))}
                    {evento.tarefas.length > 3 && (
                        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#94a3b8', textAlign: 'center' }}>
                            + {evento.tarefas.length - 3} outras tarefas
                        </p>
                    )}
                </div>
            </div>
        )}
    </div>
);

export default ProximoEventoCard;
